// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__7RgRM","inner":"Footer_inner__1zJqe"};